import { createContext, useContext, useState } from "react";

const MenuContext=createContext()

export const MenuProvider=({children})=>{
    const [menuCollapse,setMenuCollapse]=useState(false)
    return(
        <MenuContext.Provider value={{menuCollapse,setMenuCollapse}}>
            {children}
        </MenuContext.Provider>
    )
}

export const MenuSaving=()=>useContext(MenuContext)